/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-25T22:13:39.999
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHourseEntrust,
	listHourseEntrustInit,
	listHourseEntrustByAuthorizations,
	deleteHourseEntrust
	
} from '@api/storagemanage/HourseEntrust';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHourseEntrust({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHourseEntrust(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHourseEntrustByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHourseEntrustByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHourseEntrustInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHourseEntrustInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHourseEntrust({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHourseEntrust({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
